/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/

import lang from 'quasar/lang/fr'


import Vue from 'vue'

import {Quasar,QLayout,QHeader,QDrawer,QPageContainer,QPage,QToolbar,QToolbarTitle,QAvatar,QBadge,QBtn,QBtnGroup,QBtnDropdown,QIcon,QList,QImg,QItem,QItemSection,QItemLabel,QSelect,QSeparator,QCard,QCardSection,QCardActions,QInput,QStepper,QStep,QStepperNavigation,QTable,QTr,QTd,QBreadcrumbs,QBreadcrumbsEl,QTabs,QTab,QTabPanels,QTabPanel,QRouteTab,QScrollArea,QDate,QPopupProxy,QLinearProgress,QToggle,QMenu,QTimeline,QTimelineEntry,QExpansionItem,QChip,QCheckbox,QRange,QDialog,Ripple,Meta,Loading,Notify,Dialog} from 'quasar'


Vue.use(Quasar, { config: {"loading":{"delay":1000},"notify":{"position":"bottom-right"}},lang: lang,components: {QLayout,QHeader,QDrawer,QPageContainer,QPage,QToolbar,QToolbarTitle,QAvatar,QBadge,QBtn,QBtnGroup,QBtnDropdown,QIcon,QList,QImg,QItem,QItemSection,QItemLabel,QSelect,QSeparator,QCard,QCardSection,QCardActions,QInput,QStepper,QStep,QStepperNavigation,QTable,QTr,QTd,QBreadcrumbs,QBreadcrumbsEl,QTabs,QTab,QTabPanels,QTabPanel,QRouteTab,QScrollArea,QDate,QPopupProxy,QLinearProgress,QToggle,QMenu,QTimeline,QTimelineEntry,QExpansionItem,QChip,QCheckbox,QRange,QDialog},directives: {Ripple},plugins: {Meta,Loading,Notify,Dialog} })
